<template>
  <div>
    <div id="sidebar">
      <v-form id="search-form">
        <input
          name="q"
          type="text"
          v-model="url"
          placeholder="Search Bing..."
          @keydown.enter.prevent="loadUrlWithDelay"
          @input="onInputChange"
          autocomplete="on"
          autofocus
        />
        <v-btn type="submit" id="search" @click="loadUrlWithDelay" style="display: none;">Search</v-btn>
      </v-form>
    </div>
    <iframe
      id="main_frame"
      :src="newUrl"
      ref="iframe"
      class="browserframe netframe"
    ></iframe>
  </div>
</template>

<script>
import Vue from "vue";
import debounce from "lodash.debounce";

export default Vue.extend({
  data() {
    return {
      msg: "",
      url: "",
      newUrl: "",
      inputTimeout: null,
    };
  },
  watch: {
    url: {
      handler() {
        this.debouncedLoadUrl();
      },
    },
  },
  methods: {
    loadUrl() {
      const newUrl = this.url.startsWith("https://www.bing.com/search?q=")
        ? this.url
        : `https://www.bing.com/search?q=${this.url}`;
      this.newUrl = newUrl;
    },
    loadUrlWithDelay() {
      this.debouncedLoadUrl();
    },
    onInputChange() {
      clearTimeout(this.inputTimeout);
      this.inputTimeout = setTimeout(() => {
        this.submitSearchButton();
      }, 2000);
    },
    submitSearchButton() {
      document.getElementById("search").click();
    },
    goBack() {
      this.$refs.iframe.contentWindow.history.back();
    },
    goForward() {
      this.$refs.iframe.contentWindow.history.forward();
    },
  },
  created() {
    this.debouncedLoadUrl = debounce(this.loadUrl, 0);
  },
});
</script>

<style scoped>
#netframe {
  float: right;
  height: 100%;
  width: 70%;
}

#sidebar {
  float: left;
  height: 100%;
  width: 30%;
}
.browserframe {
  margin-top: -30px;
  height: 700px;
  width: 100%;
}
  .form-control-7 {
    border: 1px solid rgb(97, 192, 113);
    padding: 10px 4px;
    margin-block: 1px 1px;
    margin-top: 100px;
    margin-left: 150px;
    border-radius: 20px;
  }
  @media only screen and (max-width: 600px) {
  .form-control-7 {
    border: 1px solid #5e6570;
    padding: 20px 20px;
    margin-block: 3px 5px;
    border-radius: 10px;
    font-size: 12px;
    background: transparent;
    color: rgb(36, 212, 65);
  }
  }
  .searchcontainer {
    padding: 50px 50px;
  }
  #search-form {
    width: 80%;
  }
  #search-form input {
    padding: 15px 15px;
    border: 1px solid rgb(97, 192, 113);
    width: 547px;
    margin-top: -60px;
    margin-left: 80px;
    border-radius: 10px;
    font-size: 12px;
    background: transparent;
    color: primary;
    text-transform: capitalize;
  }
  .info {
    top: 50px;
    margin-left: 33rem;
    width: 300px;
    text-align: center;
    font-size: 1.2rem;
    position: absolute;
    padding-left: 5px;
    padding-right: 5px;
    font-style: normal;
    color: rgb(51, 207, 77);
    border-radius: 5px;
  }
  @media (max-width: 1200px) {
    #search-form { width: 50%; }
  }
  @media (max-width: 768px) {
    .container { padding: 30px 35px; }
    #search-form { width: 100%; }
    .info { font-size: 0.5rem; }
  }
</style>
